export enum DynamicOn {
    Value = 'value',
    Type = 'type',
}
